import { render } from "./HomeHero.vue?vue&type=template&id=cde5b252&scoped=true&ts=true&lang=pug"
import script from "./HomeHero.vue?vue&type=script&lang=ts&setup=true"
export * from "./HomeHero.vue?vue&type=script&lang=ts&setup=true"

import "./HomeHero.vue?vue&type=style&index=0&id=cde5b252&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cde5b252"]])

export default __exports__